
import { StorageService } from "@/services/storageService.js";
export default [
    {
        path: "/pdp",     
        beforeEnter: (to, from, next) => {
            const user = new StorageService().getItem('userProfile');
            const profileType = user?.userProfile?.profileType;

            // Not logged in -> go to login
            if (!profileType) {
                next('/login');
                return;
            }

            const isAdmin = profileType === 'INSTITUTION_ADMIN' || profileType === 'SUPER_ADMIN';

            // Admins land on the manager view; everyone else (INSTITUTION_USER,
            // SUPERVISOR, MRIT, ...) lands on their own PDP list.
            if (isAdmin && to.path === '/pdp') {
                next('/pdp/managerpdp');
            } else if (!isAdmin && to.path === '/pdp/managerpdp') {
                next('/pdp');
            } else {
                next();
            }
        },
        
        children: [
            {
                path: '/pdp',
                name: 'pdp',
                component: () => import('@/views/pdp/pdpList.vue')
            },
            {
                path: '/pdp/:userId',
                name: 'userPdp',
                component: () => import('@/views/pdp/pdpList.vue')
            },
            {
                path: 'managerpdp',
                name: 'managerPdp',
                component: () => import('@/views/pdp/managerPdpList.vue'),
            },
            {
                path: 'details/:pdpId',
                name: 'pdpDetails',
                component: () => import('@/views/pdp/pdpDetails/pdpDetails.vue'),
                children: [
                    {
                        path: 'tech-details',
                        name: 'techDetails',
                        component: () => import('@/views/pdp/pdpDetails/techDetails.vue')
                    },
                    {
                        path: 'material-details',
                        name: 'materialDetails',
                        component: () => import('@/views/pdp/pdpDetails/materialDetails.vue')
                    },
                    {
                        path: 'attachment-details',
                        name: 'attachmentDetails',
                        component: () => import('@/views/pdp/pdpDetails/attachmentDetails.vue')
                    },
                    {
                        path: 'remarks',
                        name: 'remarks',
                        component: () => import('@/views/pdp/pdpDetails/RemarksPage.vue')
                    },
                    {
                        path: 'challenges',
                        name: 'challenges',
                        component: () => import('@/views/pdp/pdpDetails/ChallengesPage.vue')
                    }
                ]
            }
        ]
    }

];
